import {trackerEventApi} from 'common/api/entitiesApi'
import React from 'react'
import {EntitySelector} from "common/components/reloadable/EntitySelector.tsx";

export interface Props {
    value?: number | number[]
    onChange?: (value?: number | number[]) => void
    style?: React.CSSProperties
    disabled?: boolean
    placeholder?: string
    multiple?: boolean
}

export const EventSelector = ({value, onChange, style, disabled, placeholder, multiple}: Props) => {
    function loadEntity(id: number) {
        return trackerEventApi.trackerEvent(id)
    }

    function searchEntities(search: string, size: number, page: number, advId?: number) {
        return trackerEventApi.trackerEventPage('name', 'asc', search, {query: {size, page}})
    }

    return (
        <EntitySelector
            value={value}
            onChange={onChange}
            loadEntity={loadEntity}
            searchEntities={searchEntities}
            placeholder={placeholder}
            disabled={disabled}
            style={style}
            errorText="Can't load Events"
            multiple={multiple}
        />
    )
}
